import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';

export const LETTERS_TRANSLIT = new Map([
  // Строчные
  ['ё', 'yo'],
  ['й', 'i'],
  ['ц', 'ts'],
  ['у', 'u'],
  ['к', 'k'],
  ['е', 'e'],
  ['н', 'n'],
  ['г', 'g'],
  ['ш', 'sh'],
  ['щ', 'sch'],
  ['з', 'z'],
  ['х', 'h'],
  ['ъ', "'"],
  ['ф', 'f'],
  ['ы', 'i'],
  ['в', 'v'],
  ['а', 'a'],
  ['п', 'p'],
  ['р', 'r'],
  ['о', 'o'],
  ['л', 'l'],
  ['д', 'd'],
  ['ж', 'zh'],
  ['э', 'e'],
  ['я', 'ya'],
  ['ч', 'ch'],
  ['с', 's'],
  ['м', 'm'],
  ['и', 'i'],
  ['т', 't'],
  ['ь', "'"],
  ['б', 'b'],
  ['ю', 'yu'],
  // Заглавные
  ['Ё', 'Yo'],
  ['Й', 'I'],
  ['Ц', 'Ts'],
  ['У', 'U'],
  ['К', 'K'],
  ['Е', 'E'],
  ['Н', 'N'],
  ['Г', 'G'],
  ['Ш', 'Sh'],
  ['Щ', 'Sch'],
  ['З', 'Z'],
  ['Х', 'H'],
  ['Ъ', "'"],
  ['Ф', 'F'],
  ['Ы', 'I'],
  ['В', 'V'],
  ['А', 'A'],
  ['П', 'P'],
  ['Р', 'R'],
  ['О', 'O'],
  ['Л', 'L'],
  ['Д', 'D'],
  ['Ж', 'Zh'],
  ['Э', 'E'],
  ['Я', 'Ya'],
  ['Ч', 'Ch'],
  ['С', 'S'],
  ['М', 'M'],
  ['И', 'I'],
  ['Т', 'T'],
  ['Ь', "'"],
  ['Б', 'B'],
  ['Ю', 'Yu'],
]);

@Pipe({
  name: 'translit',
  pure: false, // Необходимо, чтобы пайп перерасчитывался при изменении значения
})
@Injectable({
  providedIn: 'root',
})
export class TransliterationPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    if (this.translocoService.getActiveLang() !== 'en') {
      return value;
    }

    return value.replace(/./g, (char) => LETTERS_TRANSLIT.get(char) ?? char);
  }
}
